import React from 'react'
import { Stack, Box, Divider, Typography, Button, IconButton } from '@mui/material'
import { useFieldArray } from 'react-hook-form'
import { Add, Delete } from '@mui/icons-material'
import PropTypes from 'prop-types'
import VehicleFormLayout from 'components/layouts/VehicleFormLayout'

const VehiclesForm = ({ control, errors, watch }) => {
  const { fields, append, remove } = useFieldArray({ control, name: 'vehicles' })
  const watchFieldArray = watch('vehicles')
  const controlledFields = fields.map((field, index) => ({ ...field, ...watchFieldArray[index] }))

  return (
    <>
      <Stack flexGrow={1} sx={{ pl: 3, pr: 4 }}>
        <Typography variant="h6" color="textSecondary">
          Vehicles
        </Typography>
        <Box py={1}>
          <Divider />
        </Box>
        {controlledFields.map((field, index) => (
          <Stack flexGrow={1} key={`${field.id}`}>
            <Stack pt={3} direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
              <Typography variant="subtitle1" color="textSecondary">
                Vehicle {index + 1}
              </Typography>
              <IconButton color="error" onClick={() => remove(index)}>
                <Delete />
              </IconButton>
            </Stack>
            <VehicleFormLayout control={control} errors={errors} watch={watch} fieldPathPrefix={`vehicles.${index}`} />
          </Stack>
        ))}
        <Box mt={1}>
          <Button startIcon={<Add />} onClick={() => append({})}>
            Add New Vehicle
          </Button>
        </Box>
      </Stack>
    </>
  )
}

VehiclesForm.propTypes = {
  control: PropTypes.object,
  errors: PropTypes.object,
  watch: PropTypes.func,
}

VehiclesForm.defaultProps = {
  control: {},
  errors: {},
  watch: () => {},
}

export default VehiclesForm
